import React from 'react';
import { graphql } from 'gatsby';

import SectionItemProductTitle from '../../../../components/Section/SectionItems/SectionItemProductTitle';
import { normalizeContentPositionY, normalizeTextAlign } from '../../utils';

// Types
import { SectionItemProductTitleContainerFragment } from './__generated__/SectionItemProductTitleContainerFragment';

export const fragment = graphql`
  fragment SectionItemProductTitleContainerFragment on CMS_Section {
    contentPositionY
    headline
    headlineColor
    textAlign
  }
`;

type Props = {
  contentPositionY?: string;
  hasBackgroundImage: boolean;
  section: SectionItemProductTitleContainerFragment;
  textAlign?: string;
};

const SectionItemProductTitleContainer = ({ contentPositionY, hasBackgroundImage, section, textAlign }: Props) => {
  const headline = section.headline;

  if (typeof headline !== 'string') {
    return null;
  }

  const headlineColor = section.headlineColor;

  return (
    <SectionItemProductTitle
      contentPositionY={contentPositionY || normalizeContentPositionY(section.contentPositionY)}
      hasBackgroundImage={hasBackgroundImage}
      text={headline}
      textAlign={textAlign || normalizeTextAlign(section.textAlign)}
      textColor={headlineColor}
    />
  );
};

export default SectionItemProductTitleContainer;
